export default function PhilosophySection() {
  const principles = [
    {
      label: 'Clean Architecture',
      description:
        'Structured, modular system design that ensures long-term maintainability and adaptability as requirements evolve.',
    },
    {
      label: 'Performance Optimization',
      description:
        'Deep focus on efficiency at every layer, from rendering pipelines to data flow, delivering responsive experiences.',
    },
    {
      label: 'User-Centered Design',
      description:
        'Every engineering decision begins with the end user, resulting in intuitive interfaces and accessible interactions.',
    },
  ];

  return (
    <section className="w-full bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[600px]">
        <article className="w-full lg:w-[42%] px-6 md:px-10 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-6">
            Engineering
            <br />
            Philosophy
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-12 max-w-md">
            We follow modern software engineering practices that prioritise clean
            architecture, performance optimisation, and user-centred design. Our
            approach combines rigorous technical discipline with a genuine commitment
            to building products that stand the test of time.
          </p>

          <div className="grid grid-cols-3 gap-4 md:gap-6">
            {principles.map((item) => (
              <div key={item.label} className="flex flex-col">
                <span className="text-xs md:text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-2">
                  {item.label}
                </span>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </article>

        <aside className="w-full lg:w-[58%] relative min-h-[400px] lg:min-h-0 bg-accent-100/60 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20gradient%20background%20with%20overlapping%20abstract%20geometric%20shapes%20in%20terracotta%20and%20warm%20rose%20tones%2C%20smooth%20rounded%20rectangles%20and%20elliptical%20forms%20floating%20organically%2C%20light%20to%20dark%20gradient%20transition%2C%20minimal%20modern%20design%2C%20no%20text%2C%20no%20people%2C%20clean%20elegant%20composition%2C%20soft%20ambient%20atmosphere%2C%20subtle%20depth%20layering&width=900&height=900&seq=philosophy-decor-2026&orientation=landscape"
            alt="Abstract geometric composition representing engineering principles"
            title="Engineering philosophy visual"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
        </aside>
      </div>
    </section>
  );
}